import React, { useState } from "react";
import "./styles.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const SolutionIndustrySupport = (props) => {
  const { t } = useTranslation();
  const { isSSO, supportTitle, noLastBlock } = props;

  const SupportItem = (props) => {
    const { title, subtitle, img, contentText, reverse } = props;
    return (
      <div className="support-item-warp">
        <div className="item-title">{title}</div>
        {subtitle && <div className="item-subtitle">{subtitle}</div>}
        <div className={reverse ? "item-content reverse" : "item-content"}>
          <div className="item-img">
            <img
              src={`//files.authing.co/authing-website/${img}`}
              alt="authing"
            />
          </div>
          <div className="item-text-warp">{contentText}</div>
        </div>
      </div>
    );
  };
  return (
    <section className="solution-industry-support">
      <div className="inner">
        <Title title={supportTitle} align="left" />
        <SupportItem
          title={t("solution.detail.enterprise.support.api.title")}
          subtitle={t("solution.detail.enterprise.support.api.subtitle")}
          img="solution-industry-api-img.png"
          contentText={
            <>
              <div className="item-text">
                <div className="item-text-title">
                  {t("solution.detail.enterprise.support.api.item1.title")}
                </div>
                <div className="item-text-descript">
                  {t("solution.detail.enterprise.support.api.item1.descript")}
                </div>
              </div>
              <div className="item-text">
                <div className="item-text-title">
                  {t("solution.detail.enterprise.support.api.item2.title")}
                </div>
                <div className="item-text-descript">
                  {t("solution.detail.enterprise.support.api.item2.descript")}
                </div>
              </div>
              <div className="item-text">
                <div className="item-text-title">
                  {t("solution.detail.enterprise.support.api.item3.title")}
                </div>
                <div className="item-text-descript">
                  {t("solution.detail.enterprise.support.api.item3.descript")}
                </div>
              </div>
            </>
          }
        />
        <SupportItem
          title={t("solution.detail.enterprise.support.security.title")}
          img="solution-industry-security-img.png"
          reverse="true"
          contentText={
            <>
              <div className="item-text">
                <div className="item-text-descript">
                  {t("solution.detail.enterprise.support.security.descript1")}
                </div>
              </div>
              <div className="item-text">
                <div className="item-text-descript">
                  <span className="strong">
                    {t(
                      "solution.detail.enterprise.support.security.descript2-title"
                    )}
                  </span>
                  {t("solution.detail.enterprise.support.security.descript2")}
                </div>
              </div>
              <div className="item-text">
                <div className="item-text-descript">
                  <span className="strong">
                    {t(
                      "solution.detail.enterprise.support.security.descript3-title"
                    )}
                  </span>
                  {t("solution.detail.enterprise.support.security.descript3")}
                </div>
              </div>
              <div className="item-text">
                <div className="item-text-descript">
                  <span className="strong">
                    {t(
                      "solution.detail.enterprise.support.security.descript4-title"
                    )}
                  </span>
                  {t("solution.detail.enterprise.support.security.descript4")}
                </div>
              </div>
            </>
          }
        />
        {noLastBlock ? (
          ""
        ) : (
          <SupportItem
            title={t("solution.detail.enterprise.support.sso.title")}
            subtitle={t("solution.detail.enterprise.support.sso.subtitle")}
            img="sso-access-img-v2.png"
            contentText={
              <>
                <div className="item-text">
                  <div className="item-text-title">
                    {t("solution.detail.enterprise.support.sso.item1.title")}
                  </div>
                  <div className="item-text-descript">
                    {t(
                      "solution.detail.enterprise.support.sso.item1.descript1"
                    )}
                  </div>
                </div>
                <div className="item-text">
                  <div className="item-text-descript">
                    {t(
                      "solution.detail.enterprise.support.sso.item1.descript2"
                    )}
                  </div>
                </div>
              </>
            }
          />
        )}
      </div>
    </section>
  );
};
